import routes from "../routes";
import _ from "lodash";
import { useLocation, Route, Switch } from "react-router-dom";
import React from "react";
import { withPaymentConfig } from "../hooks/withPaymentConfig";
import NotFound from "../views/404";

function PaymentLayout({ paymentConfig, loading,generalData }) {
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (_.includes(prop.path, "/dashboard/payment")) {
        return (
          <Route
            exact
            path={`${prop.path}`}
            render={(props) => <prop.component loading={loading} generalData={generalData}  paymentConfig={paymentConfig} {...props} />}
            key={key}
          />
        );
      }
      return false;
    });
  };
  return (
    <Switch>
      {getRoutes(routes)}
      <Route path={`*`} component={NotFound} key="not-found" />
    </Switch>
  );
}

export default withPaymentConfig(PaymentLayout);
